import React from 'react';

import util from 'util/baseUtil';


const File = ({ attach }) => {
  const { org_file, end_date, save_file, file_size } = attach;

  const handleClick = () => {
    util.download(`${process.env.REACT_APP_FILE_API_URL}?type=1&serverfile=${save_file}`, org_file);
  }

  return (
    <div className="cont">
      <div className="txt">
        <div className="data">
          <strong>{org_file || '-'}</strong>
          <p><br /></p>
          <p>유효기간 : {('~' + end_date || '-').replace(/\//g, '.')}</p>
          <p>용량 : {util.formatFileSize(file_size)}</p>
        </div>
      </div>
      <div className="file">
        <button type="button" className="fileCnt">첨부파일 <span>1</span>개</button>
        <ul>
          <li>
            <button 
              type="button" 
              title={`${org_file} \n\n유효기간 : ${('~' + end_date || '-').replace(/\//g, '.')}\n용량 : ${util.formatFileSize(file_size)}`} 
              onClick={handleClick}>
                {org_file}
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default React.memo(File);